import { TProject } from "~/types/project";
import { baseService } from "../base";
import { PaginationParams, PaginationResponse } from "../type";
import { CreateProjectParams, UpdateProjectParams } from "./project.types";

export const projectServices = {
  getProjects: async (params?: PaginationParams) => {
    const { data } = await baseService.get<PaginationResponse<TProject>>(
      "/projects",
      {
        params: params ?? {
          page: 1,
          pageSize: 50,
        },
      }
    );
    return data;
  },
  getProject: async (id: string) => {
    const { data } = await baseService.get<TProject>(`/projects/${id}`);
    return data;
  },
  createProject: async (body: CreateProjectParams) => {
    const { data } = await baseService.post("/projects", body);
    return data;
  },
  updateProject: async (id: string, body: UpdateProjectParams) => {
    const { data } = await baseService.patch(`/projects/${id}`, body);
    return data;
  },
  deleteProject: async (id: string) => {
    const { data } = await baseService.delete(`/projects/${id}`);
    return data;
  },
  getProjectsByInventoryServiceTickets: async (clientId?: string) => {
    const { data } = await baseService.get<TProject[]>(
      "/projects/by-inventory-service-tickets",
      {
        params: {
          clientId,
        },
      }
    );
    return data;
  },
};
